export const generateLinkWithLang = (path, lang) => {
  if (!path) return path;
  if (lang === 'fr' || lang === 'ar' || lang === 'es') {
    return `/${lang}${path.startsWith('/') ? path : '/' + path}`;
  } else {
    return path;
  }
};
